<p>
  admin-panel works!
</p>
